import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge only knows Tailwind's default scale. Teach it the brand's
 * custom font sizes (theme.css --text-micro / --text-detail); otherwise it
 * reads `text-detail` as a color and drops it when `text-ink-2` follows.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['micro', 'detail'] }],
      shadow: [{ shadow: ['xs'] }],
    },
  },
});

/** Merge class names, letting later Tailwind utilities win over earlier ones. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
